import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle, XCircle, CircleNotch } from "@phosphor-icons/react";

function Shell({ children }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-md card-crisp bg-white p-10 text-center">{children}</div>
    </div>
  );
}

export function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) return setState("error");
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/billing/status/${sessionId}`);
        if (r.data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(r.data.payment_status)) return setState("error");
      } catch (e) {}
      if (++attempts < 8) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <Shell>
      {state === "checking" && (<><CircleNotch size={48} className="mx-auto text-indigo-600 animate-spin" /><h1 className="font-heading text-2xl font-bold mt-4" data-testid="payment-checking">Confirmando pagamento...</h1><p className="text-sm text-slate-600 mt-2">Aguarde alguns segundos.</p></>)}
      {state === "paid" && (<><CheckCircle size={56} weight="fill" className="mx-auto text-emerald-500" /><h1 className="font-heading text-2xl font-bold mt-4" data-testid="payment-success">Assinatura ativada!</h1><p className="text-sm text-slate-600 mt-2">Seu plano já está liberado. Bom trabalho e bons preços!</p><div className="mt-4 rounded-md bg-[#FBF6EA] border border-[#E3D3AE] p-3 text-sm text-[#5C4414]" data-testid="payment-partner-code">Bônus: <strong>30% no Seu Chamador</strong> com o cupom <code className="font-mono-nums font-bold">PARCEIRO</code> em <a href="https://oseuchamador.com" target="_blank" rel="noreferrer" className="underline">oseuchamador.com</a></div><Button asChild className="mt-6 bg-indigo-600 hover:bg-indigo-700"><Link to="/app/billing" data-testid="payment-go-app">Ir para o sistema</Link></Button></>)}
      {state === "timeout" && (<><CircleNotch size={48} className="mx-auto text-amber-500" /><h1 className="font-heading text-2xl font-bold mt-4">Ainda processando</h1><p className="text-sm text-slate-600 mt-2">O pagamento está sendo confirmado. Verifique seu plano em instantes.</p><Button asChild variant="outline" className="mt-6"><Link to="/app/billing">Ver meu plano</Link></Button></>)}
      {state === "error" && (<><XCircle size={56} weight="fill" className="mx-auto text-rose-500" /><h1 className="font-heading text-2xl font-bold mt-4">Não foi possível confirmar</h1><Button asChild variant="outline" className="mt-6"><Link to="/app/billing">Tentar novamente</Link></Button></>)}
    </Shell>
  );
}

export function PaymentCancelPage() {
  return (
    <Shell>
      <XCircle size={56} weight="fill" className="mx-auto text-slate-400" />
      <h1 className="font-heading text-2xl font-bold mt-4" data-testid="payment-cancel">Pagamento cancelado</h1>
      <p className="text-sm text-slate-600 mt-2">Nenhuma cobrança foi feita. Você pode assinar quando quiser.</p>
      <Button asChild variant="outline" className="mt-6"><Link to="/app/billing">Voltar aos planos</Link></Button>
    </Shell>
  );
}
